import classes from "./overlay.module.css";

export default function Overlay({ hide }) {
  return <div onClick={() => hide()}></div>;
}
